import Typography from "@mui/material/Typography";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import Grid from "@mui/material/Grid";

const ErrorPage = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        background: "#f9f9f9",
      }}
    >
      <Grid item xs={12} textAlign={"center"} marginTop={1}>
        <ErrorOutlineOutlinedIcon
          style={{ height: 100, width: 100 }}
          color="warning"
        />
      </Grid>
      <Typography variant="h4" my={2} textAlign={"center"} color="primary">
        Oops, something went wrong!
      </Typography>
      <Typography variant="subtitle1">
        We sincerely apologize for the inconvenience caused. Kindly reach out to
        the administrator for assistance.
      </Typography>
    </div>
  );
};

export default ErrorPage;
